'use client';
import { jsx } from 'react/jsx-runtime';
import { useComboBox } from '@react-aria/combobox';
import { useFilter } from '@react-aria/i18n';
import { useComboBoxState } from '@react-stately/combobox';
import { createContext, useCallback, useRef, useMemo } from 'react';
import { useListboxList, SwanListboxListContext } from '../listbox/listbox-list.context.js';
import { HEIGHT_OF_OPTIONS_TO_SHOW } from '../listbox/listbox.context.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';
import { SwanPopoverContextProvider } from '../popover/popover.context.js';

const SwanComboboxContext = createContext(void 0);
function SwanComboboxContextProvider(l) {
    let { children: p, onSelectionChange: d, selectedKey: f, disableAutoFilter: v = false, 'aria-label': C, 'aria-labelledby': h, inputValue: S, defaultInputValue: y, onInputChange: w, menuTrigger: O = 'input', allowsCustomValue: g, allowEmptyCollection: P = false, maxHeight: E, defaultItems: _ } = l, { childItems: H, items: I, disabledKeys: V } = useCollectionContext(), j = useCallback((o)=>{
        var t;
        let e = 'number' == typeof o ? o : null !== (t = null == o ? void 0 : o.toString()) && void 0 !== t ? t : '';
        null == d || d(null != e ? e : '');
    }, [
        d
    ]), { contains: k } = useFilter({
        sensitivity: 'base'
    }), A = useComboBoxState({
        children: H,
        items: I,
        defaultItems: _,
        defaultFilter: v ? void 0 : k,
        onSelectionChange: j,
        selectedKey: f,
        inputValue: S,
        defaultInputValue: y,
        onInputChange: w,
        allowsCustomValue: g,
        allowsEmptyCollection: P,
        menuTrigger: O
    }), B = useRef(null), F = useRef(null), M = useRef(null), R = useRef(null), T = useRef(null), { buttonProps: X, inputProps: D, listBoxProps: G, labelProps: L } = useComboBox({
        'aria-label': C,
        'aria-labelledby': h,
        menuTrigger: O,
        inputRef: F,
        buttonRef: B,
        listBoxRef: R,
        popoverRef: T,
        disabledKeys: V
    }, A), U = useModeExtractor(F, A.isOpen), W = useMemo(()=>({
            popoverRef: T,
            triggerRef: (null == M ? void 0 : M.current) ? M : F,
            overlayState: A,
            fullWidth: true,
            modes: U,
            maxHeight: null != E ? E : HEIGHT_OF_OPTIONS_TO_SHOW
        }), [
        F,
        T,
        M,
        A,
        U,
        E
    ]), q = useMemo(()=>({
            buttonProps: X,
            inputProps: D,
            labelProps: L,
            buttonRef: B,
            inputRef: F,
            triggerRef: M,
            setInputValue: A.setInputValue,
            menuTrigger: O
        }), [
        X,
        D,
        L,
        A,
        O
    ]), z = useListboxList(G, R, A);
    return jsx(SwanPopoverContextProvider, {
        value: W,
        children: jsx(SwanComboboxContext.Provider, {
            value: q,
            children: jsx(SwanListboxListContext.Provider, {
                value: z,
                children: p
            })
        })
    });
}
function useSwanComboboxContext() {
    return useNonNullishContext(SwanComboboxContext);
}

export { SwanComboboxContext, SwanComboboxContextProvider, useSwanComboboxContext };
